/**
 * Takes in a phone number, and outputs the last 10 digits
 *
 * @param {String} phoneNumber , the phone number
 * @returns {String} The parsed phone number (only keep the last 10 digits)
 */
 export const formatPhoneNumberOnlyDigits = phoneNumber => {
    if (!phoneNumber) return "";
    let onlyNumbers = phoneNumber.replace(/\D/g, '');
    if (onlyNumbers.length > 10) {
      onlyNumbers = onlyNumbers.slice(-10)
    }

    return onlyNumbers;
  };
  